import materialUI from "material-UI";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const BodyContainer = styled.div`
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 0 12px 12px 12px;
  margin-top: 24px;
`;

export const Row = styled.div`
  width: 100%;
  gap: 12px;
  display: flex;
  flex-direction: row;
  padding-top: 12px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

export const Title = styled.h1`
  font-family: Inter;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #333333;
`;

export const TitleInfo = styled.h1`
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 21.78px;
  letter-spacing: -0.01em;
  color: #424248;
  margin-bottom: 4px;
`;

export const TextField = styled(materialUI.TextField)`
  margin-top: 4px;
  label {
    display: none;
  }

  .MuiInputBase-root {
    border-radius: 8px;
    height: 44px;
    margin: 0;
    padding-top: 2px;
  }
  .MuiInputBase-input {
    height: 44px;
  }
  .MuiTypography-root {
    padding-top: 1px;
  }
  .MuiOutlinedInput-input {
    padding: 0 12px;
  }

  .MuiOutlinedInput-adornedEnd {
    padding-right: 4px;
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: #f2f4f8; /* Mantemos essa linha para consistência */
    input {
      color: ${colors.grey1};
    }
  }
  .MuiInputBase-root.Mui-disabled {
    background-color: #f2f4f8 !important; /* Define a cor de fundo vermelha para campos desativados */
    input {
      color: ${colors.grey1} !important;
    }
  }
  textarea {
    position: relative;
    &::-webkit-scrollbar {
      width: 5px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background: ${colors.LigthGrey};
    }
  }
`;

export const Button = styled.button`
  width: 100%;
  height: 40px;
  background: ${colors.primary};
  border-radius: 8px;
  border: none;
  color: #ffffff;
  font-family: Inter;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 17px;
  letter-spacing: -0.01em;
  cursor: pointer;
`;
